const ReviewRoutes = {
  getReviewsByProductId: 'getReviewsByProductId/',
  addReview: 'buyer/addReview',
};

export default ReviewRoutes